<div class="payment payment-receipt" *ngIf="receipt">
  <header class="modal__header">
    <h2>{{ "payment.receipt.label.your_order" | translate }}</h2>
    <a class="button button--transparent modal__button--close" (click)="closeModal()"><i class="icon icon-ui-close--sm"></i></a>
  </header>
  <div class="modal__content">
    <form class="form" [formGroup]="form" [ngClass]="{ 'form--submitted': this.formState.submitted }">
      <div class="form-block form-block__border user-details">
        <div class="form-group">
          <h3>{{ "payment.receipt.label.check_details" | translate }}</h3>
          <span class="label">{{ "payment.receipt.label.name" | translate }}</span>
          <span>{{ fullName }}</span>
        </div>

        <div class="form-group" *ngIf="showEmail">
          <span class="label">{{ "payment.receipt.label.email" | translate }}</span>
          <span>{{ user?.emailAddress }}</span>
        </div>

        <ng-container *ngIf="showAddress">
          <ng-container *ngIf="!loading; else loadingProfile">
            <div class="form-group">
              <span class="label">{{ "payment.receipt.label.address" | translate }}</span>
              <ng-container *ngIf="userAddress">
                <span>{{ userAddress.streetName }} {{ userAddress.houseNumber }}{{ userAddress.houseNumberSupplement }}</span>
                <span>{{ userAddress.postalCode }} {{ userAddress.city }}</span>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
      </div>
      <div class="form-block form-block__border">
        <h3 *ngIf="isCombinedProduct">{{ receipt.product.title }}</h3>
        <ng-container
          *ngIf="!isCharity"
          [ngTemplateOutlet]="isCombinedProduct ? combinedProduct : product"
          [ngTemplateOutletContext]="{ $implicit: receipt.selectedProducts }"
        ></ng-container>

        <ng-container
          *ngIf="isCharity"
          [ngTemplateOutlet]="charity"
          [ngTemplateOutletContext]="{ $implicit: receipt.product }"
        ></ng-container>

        <!-- Donation campaign -->
        <div *ngIf="receipt.donationCampaign?.points" class="form-group">
          <h5>{{ receipt.donationCampaign?.title }}</h5>
          <air-miles-sticker *ngIf="receipt.donationCampaign" [points]="receipt.donationCampaign.points" [size]="'sm'"></air-miles-sticker>
        </div>

        <!-- Sticky CTA -->
        <div class="form-group payment__cta" *ngIf="form">
          <air-payment-total></air-payment-total>
          <a class="link" (click)="closeModal()">{{ "payment.receipt.label.change_order" | translate }}</a>

          <div class="payment__terms" *ngIf="terms">
            <label>
              <div [internalInnerHtml]="terms" [userEventSource]="userEventSource"></div>
            </label>
          </div>

          <a
            class="button button--cta button--full"
            [class.button--disabled]="notEnoughMiles ? true : null"
            [airButtonLoading]="isSubmitting"
            (click)="onOrderClick($event)"
          >
            <span>{{ orderButtonText | translate }}</span>
          </a>
        </div>
      </div>
    </form>
  </div>
</div>

<ng-template #product let-selectedProducts>
  <div class="form-group" *ngFor="let selectedProduct of selectedProducts">
    <h4 class="h4--sm">{{ selectedProduct.amount }}x {{ selectedProduct.title }}</h4>
    <air-miles-sticker
      [points]="selectedProduct.points * selectedProduct.amount"
      [price]="selectedProduct.price * selectedProduct.amount"
      [size]="'sm'"
    ></air-miles-sticker>
  </div>
</ng-template>

<ng-template #combinedProduct let-selectedProducts>
  <div class="form-group" *ngFor="let selectedProduct of selectedProducts">
    <h4 class="h4--sm">{{ selectedProduct.amount }}x {{ selectedProduct.title }}</h4>
    <air-miles-sticker
      [points]="selectedProduct.points * selectedProduct.amount"
      [price]="selectedProduct.price * selectedProduct.amount"
      [size]="'sm'"
    ></air-miles-sticker>
  </div>
</ng-template>

<ng-template #charity let-charity>
  <div class="form-group">
    <h4 class="h4--sm">{{ charity.title }}</h4>
    <air-miles-sticker [points]="charity.points" [price]="charity.price" [size]="'sm'"></air-miles-sticker>
  </div>
</ng-template>

<ng-template #loadingProfile>
  <div class="form-group loading">
    <span class="label">{{ "payment.receipt.label.address" | translate }}</span>
    <span>{{ "general.label.loading" | translate }}</span>
    <span>{{ "general.label.loading" | translate }}</span>
  </div>
</ng-template>
